import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class CutBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.cut;
        this.iframeBehaviorListeners = [{ type: this.id, listener: this.handler }];
    }
}
export default CutBehavior;
